module.exports = __webpack_public_path__ + "static/media/flikidsDutch copy.f68b0958.jpg";